import {
	Button,
	IconButton,
	Popover,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
} from "@material-ui/core";
import { Add, Remove } from "@material-ui/icons";
import numeral from "numeral";
import React, { useState } from "react";
import {
	calculaValorFinalProduto,
	calculaValorUnitarioFinalProduto,
} from "../../Uteis.js/Monetario";

const ProdutosAdicionados = (props) => {
	const [alterandoDescontoIndex, setAlterandoDescontoIndex] = useState(null);
	const [valorDescontoAlterando, setValorDescontoAlterando] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);
	// const [popOverOpen, setPopOverOpen] = useState(null);

	const aplicarAlteracaoDesconto = () => {
		let valor = parseFloat(valorDescontoAlterando);
		valor = valor >= 100 ? 99 : valor;
		valor = valor < 0 ? 0 : valor;

		const produtos = props.orcamentoProdutos.map((item, index) => {
			let novo = {};
			const productGroup = props.orcamentoProdutos[index];
			if (index === alterandoDescontoIndex) {
				novo = {
					...productGroup,
					desconto: valor,
					valor_final: calculaValorFinalProduto(productGroup, valor),
					valor_unitario: calculaValorUnitarioFinalProduto(productGroup, valor),
				};
			} else {
				novo = item;
			}

			return novo;
		});
		props.AtualizaDadosOrcamento({ listaPordutos: produtos });

		setAlterandoDescontoIndex(null);
		setValorDescontoAlterando(null);
	};

	const alterarDesconto = (event, index) => {
		setAnchorEl(event.currentTarget);
		setAlterandoDescontoIndex(index);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setAlterandoDescontoIndex(null);
		setValorDescontoAlterando("");
	};

	return (
		<div
			id="produtoSelecionadosContainer"
			className="produto-selecionados-container"
		>
			<Popover
				id={"alteraPorcentagem"}
				open={alterandoDescontoIndex !== null}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
			>
				<div className="p-1">
					<TextField
						id={props.elementId}
						label="Porcentagem de desconto"
						type="Number"
						autoComplete={"off"}
						size="small"
						value={valorDescontoAlterando ? valorDescontoAlterando : ""}
						onChange={(e) => setValorDescontoAlterando(e.target.value)}
						autoFocus
					/>
					<div className="mt-1">
						<Button
							className="mr-1"
							variant="contained"
							color="primary"
							size="small"
							onClick={() => aplicarAlteracaoDesconto()}
						>
							Alterar
						</Button>
						<Button
							variant="contained"
							color="secondary"
							size="small"
							onClick={handleClose}
						>
							Cancelar
						</Button>
					</div>
				</div>
			</Popover>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell align="center">Qtd</TableCell>
							<TableCell>Produto</TableCell>
							<TableCell align="right" width="120px">
								Valor Tabela
							</TableCell>
							{!props.simples && (
								<TableCell size="small" align="center">
									Desconto
								</TableCell>
							)}
							{!props.simples && (
								<React.Fragment>
									<TableCell align="right" width="120px">
										Valor Final Un.
									</TableCell>
									<TableCell align="right" width="120px">
										Valor Final
									</TableCell>
								</React.Fragment>
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						<React.Fragment>
							{props.orcamentoProdutos &&
								props.orcamentoProdutos.map((produto, i) => {
									if (!produto) return;
									// console.log("produto", produto);
									return (
										<TableRow key={produto.id + "" + i}>
											<TableCell align="center">
												<IconButton
													aria-label="delete"
													size="small"
													onClick={() =>
														props.AdicionaRemoveProduto(produto.id, "remove")
													}
												>
													<Remove fontSize="inherit" />
												</IconButton>
												<div className="productGroupsSelected__amount">
													{produto.quantidade}
												</div>
												<IconButton
													aria-label="delete"
													size="small"
													onClick={() =>
														props.AdicionaRemoveProduto(produto.id, "add")
													}
												>
													<Add fontSize="inherit" />
												</IconButton>
											</TableCell>
											<TableCell>{produto.nome}</TableCell>
											<TableCell align="right">
												{numeral(produto.valor_tabela).format("$0,0.00")}
											</TableCell>
											{!props.simples && (
												<TableCell align="center">
													<Button
														size="small"
														variant="contained"
														color="primary"
														onClick={(e) => alterarDesconto(e, i)}
														className="btn-extra-small"
													>
														{produto.desconto
															? parseFloat(produto.desconto.toFixed(2))
															: "0"}
														%
													</Button>
												</TableCell>
											)}
											{!props.simples && (
												<TableCell align="right">
													{numeral(
														calculaValorUnitarioFinalProduto(produto)
													).format("$0,0.00")}
												</TableCell>
											)}
											{!props.simples && (
												<TableCell align="right">
													{numeral(
														calculaValorFinalProduto(
															produto,
															produto.desconto,
															produto.valor_tabela,
															produto.quantidade
														)
													).format("$0,0.00")}
												</TableCell>
											)}
										</TableRow>
									);
								})}
						</React.Fragment>
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default ProdutosAdicionados;
